var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDmSankey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M477.66 0H22.3398C10.0019 0 0 10.0019 0 22.3398V477.66C0 489.998 10.0019 500 22.3398 500H477.66C489.998 500 500 489.998 500 477.66V22.3398C500 10.0019 489.998 0 477.66 0Z",
    fill: "#E9E9EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2183_54240",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 22,
    width: 457,
    height: 456
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M478.248 22.0449H22.0459V477.953H478.248V22.0449Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2183_54240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.848 98.1766H40.2705C30.2053 98.1766 22.0459 106.336 22.0459 116.401V383.303C22.0459 393.368 30.2053 401.528 40.2705 401.528H458.848C468.913 401.528 477.072 393.368 477.072 383.303V116.401C477.072 106.336 468.913 98.1766 458.848 98.1766Z",
    fill: "white",
    stroke: "#C1C1C1",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M458.848 -243.681H40.2705C30.2053 -243.681 22.0459 -235.522 22.0459 -225.457V41.4453C22.0459 51.5104 30.2053 59.6698 40.2705 59.6698H458.848C468.913 59.6698 477.072 51.5104 477.072 41.4453V-225.457C477.072 -235.522 468.913 -243.681 458.848 -243.681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M460.024 440.622H40.2705C30.2053 440.622 22.0459 448.782 22.0459 458.847V715.461C22.0459 725.526 30.2053 733.685 40.2705 733.685H460.024C470.089 733.685 478.248 725.526 478.248 715.461V458.847C478.248 448.782 470.089 440.622 460.024 440.622Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2559 138.742V122.281H239.565V138.742H65.2559Z",
    fill: "#3663AC",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.281 179.894C108.466 175.191 90.5351 171.664 65.2559 171.664V139.036C93.7685 139.036 115.52 142.857 133.451 149.324C151.382 155.497 164.609 164.021 175.779 171.664C178.131 173.134 180.188 174.897 182.246 176.367C200.47 189.301 213.11 198.119 239.271 198.119V230.747C201.646 230.747 181.07 216.05 162.552 202.822C160.494 201.352 158.436 199.883 156.379 198.413C146.385 191.358 136.097 184.891 122.281 180.188V179.894Z",
    fill: "#3663AC",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.543 206.349C153.145 218.695 123.457 230.747 64.9619 230.747V181.658C114.345 181.658 136.097 171.958 154.321 162.846C156.379 161.67 158.436 160.788 160.494 159.612C179.306 149.618 201.058 139.036 239.271 139.036V187.537C213.698 187.537 201.94 193.71 184.01 202.822C181.952 203.998 179.6 205.174 177.249 206.349H177.543Z",
    fill: "#3663AC",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.565 376.837H65.2559V230.453H239.565V376.837Z",
    fill: "#3663AC",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7344 122.575H64.9619V171.664H51.7344V122.575Z",
    fill: "#3663AC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7344 181.364H64.9619V376.837H51.7344V181.364Z",
    fill: "#3663AC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.69 173.134H252.793V122.281H427.69V173.134Z",
    fill: "#45C0F0",
    fillOpacity: 0.3
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M373.31 360.67C345.679 368.901 314.227 376.837 252.793 376.837V197.825C291.887 197.825 305.703 193.71 318.342 189.889C318.636 189.889 319.224 189.889 319.518 189.595C320.106 189.595 320.694 189.301 320.988 189.007C344.797 181.658 373.31 173.134 427.984 173.134V352.146C400.353 352.146 390.947 355.085 376.543 359.495C375.368 359.789 374.192 360.376 372.722 360.67H373.31Z",
    fill: "#45C0F0",
    fillOpacity: 0.3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.115 214.286C291.593 197.825 275.426 187.243 252.793 187.243V173.134C281.011 173.134 301 186.361 316.579 205.468C331.864 223.986 342.74 248.677 352.734 272.193C353.616 274.251 354.497 276.014 355.085 278.072C364.492 299.824 373.31 320.4 384.186 335.979C395.944 352.734 409.465 362.434 427.396 362.434V376.543C402.704 376.543 385.362 362.728 372.134 343.916C360.376 326.867 350.97 305.115 341.564 283.657C340.682 281.599 339.8 279.542 338.918 277.484C328.63 253.675 318.342 231.041 304.527 213.992L305.115 214.286Z",
    fill: "#45C0F0",
    fillOpacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M252.793 122.575H239.565V187.537H252.793V122.575Z",
    fill: "#45C0F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M252.793 197.825H239.565V376.837H252.793V197.825Z",
    fill: "#45C0F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M440.917 122.869H427.69V352.734H440.917V122.869Z",
    fill: "#52B163"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M440.917 363.316H427.69V377.425H440.917V363.316Z",
    fill: "#52B163"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmSankey);
export default __webpack_public_path__ + "static/media/dm_sankey.7d7d45d7.svg";
export { ForwardRef as ReactComponent };